import React from 'react';
import { TOOLTIP_POSITION, TooltipV2 as Tooltip } from 'taboola-ultimate-ui';
import { prettifyJson, extractConditions, isS2sIntegration } from 'modules/PixelTester/utils/utils';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { CONVERSION_TYPE } from 'modules/tracking/config';
import { DetailRow } from '../DetailRow/DetailRow';
import { ParameterList } from '../ParameterList/ParameterList';
import { UserMatching } from '../UserMatching/UserMatching';
import styles from './eventData.module.scss';

export const EventData = ({ eventData, eventType, showUserMatching }) => {
    const { accountId, url, eventName, eventParameters, content, userMatching, pixelIntegrationType, issues } =
        eventData;

    const formattedContent = content ? prettifyJson(content) : null;
    const isUrlEvent = eventType === CONVERSION_TYPE.BASIC;
    const parameters = isUrlEvent ? extractConditions(eventData) : eventParameters;
    const isS2S = isS2sIntegration(pixelIntegrationType);

    const { defaultMessage, id } = isUrlEvent
        ? { defaultMessage: 'Conditions', id: 'conditions' }
        : { defaultMessage: 'Parameters', id: 'parameters' };

    return (
        <div className={styles['event-details']}>
            {accountId && (
                <DetailRow labelId="pixel.tester.event.account.id.title" defaultLabel="Account ID">
                    {accountId}
                </DetailRow>
            )}
            <DetailRow labelId="pixel.tester.event.type.title" defaultLabel="Type">
                <FormattedMessage
                    id={isUrlEvent ? 'pixel.tester.url.subtitle' : 'pixel.tester.type.event'}
                    defaultMessage={isUrlEvent ? 'URL' : 'Event'}
                />
            </DetailRow>
            {!isUrlEvent && (
                <DetailRow labelId="pixel.tester.event.name.title" defaultLabel="Event Name">
                    {eventName}
                </DetailRow>
            )}
            {url && (
                <DetailRow labelId="pixel.tester.event.data.url.parameter.title" defaultLabel="Page URL">
                    <a href={url} target="_blank" rel="noreferrer">
                        {url}
                    </a>
                </DetailRow>
            )}

            <ParameterList parameters={parameters} isUrlEvent={isUrlEvent} id={id} defaultMessage={defaultMessage} />

            {showUserMatching && (
                <UserMatching
                    userMatchingData={userMatching}
                    hideCookieConsentData={isS2S}
                    userMatchingIssueType={issues?.userMatchingIssueType}
                />
            )}

            {formattedContent && (
                <div className={styles['container']}>
                    <FormattedMessage
                        id="pixel.tester.event.data.contents.title"
                        defaultMessage="Contents"
                        className={styles['key']}
                    />
                    <div className={styles['content-value']}>{formattedContent}</div>
                    <Tooltip arrow placement={TOOLTIP_POSITION.BOTTOM}>
                        {formattedContent}
                    </Tooltip>
                </div>
            )}
        </div>
    );
};
